import React from 'react';
import PropTypes from 'prop-types';
import { NODE_PARAGRAPH, render } from 'storyblok-rich-text-react-renderer';
import { Paragraph } from '../atoms';
import { interpolateObject } from './objInteraction';
import { CMSBlok } from './translation';

export const RichText = ({
  content,
  inline = false,
  interpolationValues = {},
}) => {
  if (!content) {
    return null;
  }

  const Wrapper = inline ? React.Fragment : 'div';

  return (
    <Wrapper>
      {render(interpolateObject(content, interpolationValues), {
        nodeResolvers: {
          [NODE_PARAGRAPH]: (children, props) =>
            inline ? (
              <>
                {children}
                <br />
              </>
            ) : (
              <Paragraph {...props}>{children}</Paragraph>
            ),
        },
        defaultBlokResolver: (component, props) => (
          <CMSBlok content={{ component, ...props }} />
        ),
      })}
    </Wrapper>
  );
};

RichText.displayName = 'RichText';

RichText.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  inline: PropTypes.bool,
  interpolationValues: PropTypes.object,
};
